import { Injectable, inject } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DialogComponent } from '@components/dialog/dialog.component';
import { SharedConstants } from '@formbird/types';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
    dialog = inject(MatDialog);


    dialogRef: MatDialogRef<DialogComponent>;
    swal: any; // TODO: Remove if no longer used in rules/component source
    openModal: any;

    isOpen: boolean = false;
    constructor() {
        this.openModal = (options: any, message?: string, type?: string) => {
            if (typeof options === 'object') {
                this.openDialog(options);
            } else {
                const data: any = {
                    title: options,
                    html: `<p>${message}</p>`,
                    messageType: type,
                    confirmButton: true
                };

                this.openDialog({ data });
            }
        };

        // swal function have arguments ({title, message, type}, callback(true)) or (title, message, type)
        this.swal = async (swalOptions: any, callback?: any, type?: string) => {
            // deprecated, remove when no longer used
            console.warn('Deprecated: Please use functions openDialog and openModal. '
                + 'SweetAlert(swal) is now replaced with material dialog. The '
                + 'swal(title, message, type) and swal(options) functions will be removed in the future.');

            let message = '';
            if (typeof callback === 'string') {
                message = callback;
            }

            if (typeof swalOptions === 'object') {
                // convert swal options
                // retaining the definite features from
                // https://www.formbird.com/docs/5.Rulesets/060-Ruleset_Functions/#options_1
                const dialogOptions: any = {
                    data: {
                        title: swalOptions.title || swalOptions.titleText,
                        html: swalOptions.html || `<p>${swalOptions.text || ''}</p>`,
                        messageType: swalOptions.type || 'info',
                        ...swalOptions,
                        succFunc: () => {
                            const isConfirmed = true;
                            if (callback) {
                                callback(isConfirmed);
                            }
                        },
                        errorFunc: swalOptions.showCancelButton ? () => {
                            const isConfirmed = false;
                            if (callback) {
                                callback(isConfirmed);
                            }
                        } : null
                    }
                };

                dialogOptions.width = swalOptions.width || '500px';
                dialogOptions.disableClose = swalOptions.allowOutsideClick === false
                    || swalOptions.allowEscapeKey === false;
                dialogOptions.autoFocus = true;

                return this.openDialog(dialogOptions);
            } else {
              this.openModal(swalOptions, message, type);
            }
        };

        this.swal.close = this.openModal.close = () => {
            this.closeDialog();
        };
    }

    openDialog(options: any) {
        if (!options) return Promise.resolve();
        
        if (options.data && options.data.component) {
          this.dialogRef = this.dialog.open(options.data.component, options);
        } else {
          this.dialogRef = this.dialog.open(DialogComponent, options);
        }

        if (options.data.timer) {
            setTimeout(() => {
                this.dialogRef.close();
            }, options.data.timer);
        }

        return this.dialogRef.afterClosed().toPromise();
    }

    closeDialog() {
        this.dialogRef.close();
    }

    showDialog(
        message: string,
        messageType?: string,
        succFunc?: Function,
        errorFunc?: Function,
        discardFunc?: Function,
        closeFunc?: Function,
        options?: any
    ): void {
        if (this.isOpen) {
            console.warn('Dialog is already open. Aborting new dialog request to prevent duplicate modals.');
            return;
        }

        if (!messageType) {
            messageType = SharedConstants.STATUS_SUCCESS;
        }

        const type = messageType?.toLowerCase() ?? SharedConstants.STATUS_SUCCESS;
        const data: any = {
            html: `<p>${message}</p>`,
            messageType: type,
            confirmButton: true,
            showCancelButton: true,
            allowEnterKey: false // prevent accidental confirm
        };

        switch (type) {
            case SharedConstants.STATUS_ERROR:
                data.title = 'Error';
                break;
            case SharedConstants.STATUS_SUCCESS:
                data.title = 'Success';
                break;
            case SharedConstants.STATUS_INFO:
                data.title = 'Info';
                data.succFunc = succFunc;
                data.errorFunc = errorFunc;
                break;
            case SharedConstants.STATUS_WARNING:
                data.title = 'Warning';
                data.confirmButton = false;
                data.succFunc = succFunc;
                data.errorFunc = errorFunc;
                data.discardFunc = discardFunc;
                break;
            default:
                data.title = 'Message';
        }

        this.isOpen = true;

        Object.assign(data, options);

        this.openDialog({ data, panelClass: ['ft-dialog', 'ft-dialog-component-wrap'] })
            .then(() => {
                closeFunc?.();
            })
            .finally(() => {
                this.isOpen = false;
            });
    }

}
